import React from 'react'

import * as S from './styles'

/**
 * @typedef {'end' | 'start'} FloatingPlacement
 */

/**
 * @typedef {'top' | 'right' | 'bottom' | 'left'} FloatingSide
 */

/**
 * @typedef {FloatingSide | `${FloatingSide}-${FloatingPlacement}`} FloatingPosition
 */

/**
 * @typedef {Object} TooltipProps
 * @property {React.ReactNode} label
 * @property {FloatingPosition} [position]
 * @property {boolean} [withArrow]
 * @property {React.ReactNode} children
 * @property {boolean} [multiline]
 * @property {number | "auto"} [width]
 * @property {boolean} [disabled]
 */

/**
 * @param {TooltipProps} props
 */
export default function Tooltip({
  label,
  position = 'top',
  withArrow = true,
  children,
  multiline = true,
  width = 400,
  disabled
}) {
  const style = {
    textAlign: 'center',
    whiteSpace: 'normal',
    color: '#FFF'
  }

  const labelView = <div style={style}>{label}</div>

  return (
    <S.Tooltip
      disabled={disabled}
      width={width}
      multiline={multiline}
      label={labelView}
      color="#5b605d"
      withArrow={withArrow}
      position={position}
      transitionProps={{ duration: 500 }}
    >
      {children}
    </S.Tooltip>
  )
}
